var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarteDeCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.25 47.25H78.75C57.8719 47.275 37.856 55.5799 23.093 70.343C8.32989 85.106 0.0250088 105.122 0 126H378C377.975 105.122 369.67 85.106 354.907 70.343C340.144 55.5799 320.128 47.275 299.25 47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 252C0.0250088 272.878 8.32989 292.894 23.093 307.657C37.856 322.42 57.8719 330.725 78.75 330.75H299.25C320.128 330.725 340.144 322.42 354.907 307.657C369.67 292.894 377.975 272.878 378 252V157.5H0V252ZM110.25 244.125C110.25 248.798 108.864 253.365 106.268 257.25C103.673 261.135 99.9828 264.164 95.6659 265.952C91.349 267.74 86.5988 268.208 82.016 267.296C77.4332 266.384 73.2236 264.134 69.9196 260.83C66.6156 257.526 64.3655 253.317 63.4539 248.734C62.5424 244.151 63.0102 239.401 64.7983 235.084C66.5865 230.767 69.6145 227.077 73.4996 224.482C77.3848 221.886 81.9524 220.5 86.625 220.5C92.8907 220.5 98.8999 222.989 103.33 227.42C107.761 231.85 110.25 237.859 110.25 244.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteDeCredit);
export default __webpack_public_path__ + "static/media/carte-de-credit.230c13e948ef114b53c39ff6565d9380.svg";
export { ForwardRef as ReactComponent };